/**
 * 获取URL中的search的参数值
 * @param name 要获取的参数名
 * @returns {*}
 * @constructor
 */
function GetQueryString(name, url = window.location.search) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = url.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

function platform() {
  var ua = navigator.userAgent, //获取浏览器UA
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    // never used
    // isChrome = /(?:Chrome|CriOS)/.test(ua),
    isWechat = /(?:MicroMessenger)/.test(ua),
    isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian,
    isMobile = !isPc,
    isYixinliApp = /(?:yixinliApp)/.test(ua),
    isCeShiApp = /(?:XinLiCeShiApp)/.test(ua)
  return {
    isWechat: isWechat,
    isTablet: isTablet,
    isPhone: isPhone,
    isAndroid: isAndroid,
    isPc: isPc,
    isMobile: isMobile,
    isYixinliApp: isYixinliApp,
    isCeShiApp: isCeShiApp
  }
}

/**
 *
 * @param dateObj 日期对象 Date Object
 * @param fmt 格式，字符串类型，YY代表年，MM代表月，DD代表日，hh时，mm分，ss秒，SS毫秒
 * @returns {*}
 */
function dateFormater(dateObj, fmt) {
  if (dateObj instanceof Date) {
    console.log('dateObj is good')
  } else if (typeof dateObj == 'string') {
    dateObj = new Date(dateObj.replace(/-/g, '/'))
  } else {
    console.error('日期数据格式错误')
    return
  }
  var o = {
    'M+': dateObj.getMonth() + 1, //月份
    'D+': dateObj.getDate(), //日
    'h+': dateObj.getHours(), //小时
    'm+': dateObj.getMinutes(), //分
    's+': dateObj.getSeconds(), //秒
    'q+': Math.floor((dateObj.getMonth() + 3) / 3), //季度
    S: dateObj.getMilliseconds() //毫秒
  }
  if (/(Y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (dateObj.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
  return fmt
}

/**
 * 数字补0
 * @param num
 * @param length
 * @returns {string}
 */
function padZero(num, length) {
  return (Array(length).join('0') + num).slice(-length)
}

/**
 * 插入script在页面
 * @param url
 * @param callback
 */
function loadScript(url) {
  window.loadedScript = window.loadedScript || []

  return new Promise(resolve => {
    if (window.loadedScript.includes(url)) {
      resolve({
        code: 1,
        msg: 'this script was loaded'
      })
    }
    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = url
    document.getElementsByTagName('head')[0].appendChild(script)

    script.onload = function() {
      script.onload = null
      window.loadedScript.push(url)
      resolve({
        code: 1,
        msg: 'script load success!'
      })
    }
  })
}

function getScrollTop() {
  // 试过了IOS和红米都有document.body.scrollTop，所以其他都不要了
  var scrollTop =
    document.documentElement.scrollTop ||
    window.pageYOffset ||
    document.body.scrollTop
  return scrollTop
}

function setScrollTop(number) {
  if (typeof number === 'number') {
    if (
      document.documentElement &&
      document.documentElement.scrollTop != undefined
    ) {
      document.documentElement.scrollTop = number
    }
    if (window.pageYOffset) {
      // window.pageYOffset = number;
    }
    if (document.body && document.body.scrollTop != undefined) {
      document.body.scrollTop = number
    }
  } else {
    console.error('设置scrollTop传入的值不是数字')
  }
}

// 输入秒数，转换成 mm:ss的格式
function secondToTime(second) {
  if (!second) return `00:00`
  let sec = padZero(Math.floor(second) % 60, 2)
  let minute = padZero(Math.floor(second / 60).toFixed(0), 2)
  return `${minute}:${sec}`
}

// 输入秒数，转换成 mm分:ss秒的格式
// function secondToTimes(second) {
// 	if (!second) return `00分00秒`
// 	let sec = padZero(Math.floor(second) % 60, 2);
// 	let minute = padZero(Math.floor(second / 60).toFixed(0), 2);
// 	return `${minute}分${sec}秒`;
// }

// 输入秒数，转换成 mm小时:ss分的格式
function formatSeconds(second) {
  var secondTime = parseInt(second) // 秒
  var minuteTime = 0 // 分
  var hourTime = 0 // 小时
  if (secondTime > 60) {
    //如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60)
    //获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60)
    //如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      //获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60)
      //获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60)
    }
  }
  if (secondTime < 10) {
    secondTime = '0' + secondTime
  }
  if (minuteTime < 10) {
    minuteTime = '0' + minuteTime
  }
  if (hourTime < 10) {
    hourTime = '0' + hourTime
  }
  // 时间转换过程会瞬间出现NaN的情况，故判断下，以免页面闪现NaN
  if (!isNaN(secondTime) && !isNaN(minuteTime)) {
    if (parseInt(hourTime) === 0) {
      return `${minuteTime}分钟${secondTime}秒`
    } else {
      return `${hourTime}小时${minuteTime}分钟`
    }
  }
}

// 输入秒数，转换成 mm时:ss分的格式
function secondToTimes(second) {
  var secondTime = parseInt(second) // 秒
  var minuteTime = 0 // 分
  var hourTime = 0 // 小时
  if (secondTime > 60) {
    //如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60)
    //获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60)
    //如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      //获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60)
      //获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60)
    }
  }
  if (secondTime < 10) {
    secondTime = '0' + secondTime
  }
  if (minuteTime < 10) {
    minuteTime = '0' + minuteTime
  }
  if (hourTime < 10) {
    hourTime = '0' + hourTime
  }
  // 时间转换过程会瞬间出现NaN的情况，故判断下，以免页面闪现NaN
  if (!isNaN(secondTime) && !isNaN(minuteTime)) {
    if (parseInt(hourTime) === 0) {
      return `${minuteTime}分${secondTime}秒`
    } else {
      return `${hourTime}时${minuteTime}分`
    }
  }
}

/**
 * 函数节流方法
 * @param Function fn 延时调用函数
 * @param Number delay 延迟多长时间
 * @param Number atleast 至少多长时间触发一次
 * @return Function 延迟执行的方法
 */
function throttle(fn, delay, atleast) {
  var timer = null
  var previous = null
  return function() {
    var now = +new Date()
    if (!previous) previous = now
    if (now - previous > atleast) {
      fn()
      // 重置上一次开始时间为本次结束时间
      previous = now
    } else {
      clearTimeout(timer)
      timer = setTimeout(function() {
        fn()
      }, delay)
    }
  }
}

/**
 * 对多字节 emoji 进行转换 HTML 字符实体的处理
 * @param str
 * @returns {string|*}
 */
function utf16toEntities(str) {
  const patt = /[\ud800-\udbff][\udc00-\udfff]/g // 检测utf16字符正则
  str = String(str)
  str = str.replace(patt, function(char) {
    var H, L, code
    if (char.length === 2) {
      H = char.charCodeAt(0) // 取出高位
      L = char.charCodeAt(1) // 取出低位
      code = (H - 0xd800) * 0x400 + 0x10000 + L - 0xdc00 // 转换算法
      return '&#' + code + ';'
    } else {
      return char
    }
  })
  return str
}

/**
 * 将字符串内部的/n/r换成<br/>
 * @param str
 */
function changeLineToBr(str) {
  var reg = new RegExp('%0A', 'g')

  str = escape(str).replace(reg, '%3Cbr/%3E')

  return str
}

// 比较手机版本号方法
//假定字符串的每节数都在5位以下
function toVersion(version) {
  version = version.toString()
  //也可以这样写 var c=a.split(/\./);
  var c = version.split('.')
  var num_place = ['', '0', '00', '000', '0000'],
    r = [...num_place].reverse()
  for (var i = 0; i < c.length; i++) {
    var len = c[i].length
    c[i] = r[len] + c[i]
  }
  var res = c.join('')
  return res
}

// lodash.pick的代替品
export function pick(obj, keys) {
  return keys.reduce(function(result, key) {
    result[key] = obj[key]
    return result
  }, {})
}

// lodash.omit的代替品
export function omit(obj, keys) {
  var result = {},
    key

  for (key in obj) {
    if (keys.indexOf(key) == -1) result[key] = obj[key]
  }

  return result
}

export {
  GetQueryString,
  dateFormater,
  platform,
  padZero,
  loadScript,
  getScrollTop,
  setScrollTop,
  secondToTime,
  secondToTimes,
  formatSeconds,
  throttle,
  utf16toEntities,
  changeLineToBr,
  toVersion
}



// WEBPACK FOOTER //
// ./src/units/index.js